import { render, staticRenderFns } from "./fixAddress-status-popup.vue?vue&type=template&id=3a0486cb&scoped=true&"
import script from "./fixAddress-status-popup.vue?vue&type=script&lang=js&"
export * from "./fixAddress-status-popup.vue?vue&type=script&lang=js&"
import style0 from "./fixAddress-status-popup.vue?vue&type=style&index=0&id=3a0486cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0486cb",
  null
  
)

export default component.exports